import { render } from "./mapControlsEmission.vue?vue&type=template&id=2ccf4246&scoped=true"
import script from "./mapControlsEmission.vue?vue&type=script&lang=js"
export * from "./mapControlsEmission.vue?vue&type=script&lang=js"

import "./mapControlsEmission.vue?vue&type=style&index=0&id=2ccf4246&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccf4246"]])

export default __exports__